module.exports = __webpack_public_path__ + "img/page404.9ea62f4d.png";